import { VerificationContext } from 'contexts/VerificationContext';
import { useContext } from 'react';

export default () => useContext(VerificationContext);
